import { useQuery } from "react-query"
import DataService from '../../../config/DataServices'

const { getRequest } = DataService()
export const useLoginHistory = ({ page, size, sortOrder, searchText , sortField}) => {

    return useQuery({
        queryKey: ["login-History", page, size, searchText,sortOrder],
        queryFn: () => {
            return getRequest(`/login-history?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortBy=${sortField}`)
        }
    })
}